<div @fade class="container-signin">
  <header class="header">
    <div class="container-logo">
      <div class="logo">
        <img (click)="goToUrl('home')" style="cursor: pointer;" src="./assets/temporals/Logo_Akana_Azul.png" alt="">
      </div>
      <div class="buttons-container">
        <p *ngIf="show === '2' || show === '3' || show === '4'">{{'SIGN.ACCOUNT' | translate}}</p>
        <p *ngIf="show === '1'">¿Eres nuevo en Akana?</p>
        <button class="sign-in" id="changeToSignUp" *ngIf="show === '2' || show === '3' || show === '4'"
          (click)="changeForm('1')">Iniciar
          sesión</button>
        <button class="sign-in" id="changeToSignIn" *ngIf="show === '1'" (click)="changeForm('2')">Crear Cuenta</button>
        <!-- <button class="guest" id="guest" *ngIf="show === '1'" (click)="goToUrl('terms', 'inv')">Entrar como
          invitado</button> -->
      </div>
    </div>
  </header>
  <div class="left">
    <img src="./assets/signin/signin.svg" alt="">
  </div>
  <div class="right">
    <div class="right-container">
      <h2 *ngIf="show === '1' || firstInit">{{startMessage}}</h2>
      <h2 *ngIf="show === '2'">
        {{(!receptionMessage && show === '2') ? '¡Únete a Akana!' : (receptionMessage && code !== 200)? 'Ups...' : 'Ya casi lo tienes'}}
      </h2>
      <h2 *ngIf="show === '3'">¿Has olvidado tu <span class="space-br"><br></span> contraseña?</h2>
      <!-- <p *ngIf="show === '3' && !receptionMessage" class="light-grey">
        Se han enviado las instrucciones para generar una nueva contraseña
      </p> -->
      <div class="form-container" style="margin-top: 15px;">
        <div class="form-sign" *ngIf="firstInit">
          <div class="message-sign-up" *ngIf="receptionMessage">
            <p>{{ receptionMessage }}</p>
            <mat-progress-bar style="width: 100%; margin: 0; max-width: 350px;" *ngIf="firstInit && showProgress"
              mode="indeterminate">
            </mat-progress-bar>
            <button *ngIf="!showProgress && receptionMessage" id="roadToSignIn"
              (click)="changeForm('1', 'roadToSignIn')">Iniciar
              sesión</button>
          </div>
        </div>
        <form autocomplete="off" method="POST" *ngIf="show === '1' && !firstInit" class="form-sign"
          [formGroup]="signForm">
          <div class="input-control-error">
            <p>Email de usuario *</p>
            <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
              formControlName="email" class="input-search" name="" placeholder="Introduce tu email"
              required="signForm.controls.email.value !== '">
            <div class="div-error"
              *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
              {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
            </div>
            <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
              [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
            </div>
          </div>
          <div style="height: 110px;" class="input-control-error">
            <p>
              {{this.param[0] === 'unlock'? 'Introduzca su contraseña' : (this.param[0] === 'change' && buttonName !== 'Iniciar sesión') ? 'Introduce una nueva contraseña' : 'Contraseña'}}
              *
            </p>
            <div class="see-pass">
              <input type="{{type}}" id="passwordId"
                [ngClass]="{'error-input': !signForm.controls.password.value && signForm.controls.password.touched }"
                formControlName="password" class="input-search" name="" placeholder="Introduce tu contraseña" required>
              <img src="./assets/signin/see_pass.svg" *ngIf="signForm.controls.password.value" (mousedown)="showPass(1)"
                (mouseup)="showPass(2)" alt="">
            </div>
            <div class="div-error" *ngIf="!signForm.controls.password.value && signForm.controls.password.touched"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
            </div>
            <div class="div-error"
              *ngIf="signForm.controls.password.value && signForm.controls.password.touched && signForm.controls.password.invalid"
              [innerHTML]=" 'SIGN.ERRORS.RECOVER_ALL_VALIDATIONS' | translate">
            </div>
          </div>
          <div *ngIf="startMessage !== '¡Bienvenido a Akana!'" class="input-control-error last-input">
            <p>Repite contraseña *</p>
            <input type="password" id="passwordTwoId"
              [ngClass]="{'error-input': !signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched }"
              formControlName="passwordTwo" class="input-search" name="" placeholder="Repita la contraseña" required>
            <div class="div-error" *ngIf="!signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
            </div>
            <div class="div-error"
              *ngIf="signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched && squals"
              [innerHTML]=" 'SIGN.ERRORS.PASSWORD_2_REQUIRED' | translate">
            </div>
          </div>
          <h3 (click)="changeForm('3')" id="forget">{{'SIGN.FORGOT_PASS' | translate}}</h3>
          <p class="errors" *ngIf="receptionMessage">{{receptionMessage}}</p>
          <button class="sign-in first" id="signInId" [ngClass]="{'ready': signForm.valid }" (click)="login(1)"
            *ngIf="!showProgress">{{ buttonName }}</button>
          <button class="sign-in create" id="changeToSignIn" *ngIf="show === '1' && !showProgress"
            (click)="changeForm('2')">{{'SIGN.TEXTPART3' | translate}}</button>
          <mat-progress-bar style="width: 95%; margin: 0 auto; max-width: 350px;" *ngIf="showProgress"
            mode="indeterminate">
          </mat-progress-bar>
          <div class="group-session">
            <p class="init-session">{{'SIGN.TEXTPART1' | translate}}<br>{{'SIGN.TEXTPART2' | translate}}</p>
            <button class="consumer" *ngIf="!showProgressConsumer" (click)="goToUrl('signinSCF')" id="signInConsumer">
              <img src="./assets/signin/flame_santander.png" alt="">&nbsp;&nbsp;&nbsp; {{'SIGN.TEXTPART4' | translate}}
            </button>
            <button class="guest" id="guestButton" (click)="goToUrl('terms', 'inv')" *ngIf="!showProgress">{{'SIGN.TEXTPART5' | translate}}</button>
          </div>
        </form>
        <form autocomplete="off" method="POST" *ngIf="show === '2'" class="form-sign" [formGroup]="signForm">
          <div *ngIf="!receptionMessage" class="container-form">
            <div class="input-control-error">
              <p>Email personal *</p>
              <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
                formControlName="email" class="input-search" name="" placeholder="Introduce tu email">
              <div class="div-error"
                *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
                {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
              </div>
              <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
                [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
              </div>
            </div>
            <div class="input-control-error">
              <p>Contraseña *</p>
              <div class="see-pass">
                <input type="{{type}}" id="passwordId"
                  [ngClass]="{'error-input': !signForm.controls.password.value && signForm.controls.password.touched }"
                  formControlName="password" class="input-search" name="" placeholder="Introduce tu contraseña"
                  required>
                <img src="./assets/signin/see_pass.svg" *ngIf="signForm.controls.password.value"
                  (mousedown)="showPass(1)" (mouseup)="showPass(2)" alt="">
              </div>
              <div class="div-error" *ngIf="!signForm.controls.password.value && signForm.controls.password.touched"
                [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
              </div>
              <div class="div-error"
                *ngIf="signForm.controls.password.value && signForm.controls.password.touched && signForm.controls.password.invalid"
                [innerHTML]="'SIGN.ERRORS.ALL_VALIDATIONS' | translate">
              </div>
            </div>
            <div class="input-control-error last-input">
              <p>Repite contraseña *</p>
              <input type="password" id="passwordTwoId"
                [ngClass]="{'error-input': !signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched }"
                formControlName="passwordTwo" class="input-search" name="" placeholder="Repita la contraseña" required>
              <div class="div-error"
                *ngIf="!signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched"
                [innerHTML]=" 'SIGN.ERRORS.PASSWORD_REQUIRED' | translate">
              </div>
              <div class="div-error"
                *ngIf="(signForm.controls.passwordTwo.value && signForm.controls.passwordTwo.touched && squals) ||
                signForm.controls.passwordTwo.value && !validPassTwo"
                [innerHTML]=" 'SIGN.ERRORS.PASSWORD_2_REQUIRED' | translate">
              </div>
            </div>
            <div class="container-checkbox">
              <mat-checkbox formControlName="ofers" id="ofersId" (click)="analiticsGoogle()" aria-label="Check Conditions"></mat-checkbox>
              <p>{{'TERMS.CONDITIONS.CHECK_2' | translate}}</p>
            </div>
            <div class="container-checkbox">
              <mat-checkbox (click)="openWarmModal()" [disabled]="checkedTerms" formControlName="termsAndConditions"
                id="termsId" required aria-label="Check Terms">
              </mat-checkbox>
              <p>{{ 'TERMS.CONDITIONS.CHECK_1' | translate}}
                <strong (click)="goToUrl('terms-conditions?signin=true')"
                  class="text-box">{{'TERMS.CONDITIONS.CHECK_TERMS_1' | translate}}</strong>{{'TERMS.CONDITIONS.CHECK_BETWEEN' | translate }}
                <strong (click)="goToUrl('privacy-polity')"
                  class="text-box">{{ 'TERMS.CONDITIONS.CHECK_POLITY' | translate}}</strong>.
              </p>
            </div>
            <button class="sign-in" style="margin: 17px 20px 0 0;" [ngClass]="{ 'ready': signForm.valid && validPassTwo}"
              (click)="login(2)" *ngIf="!showProgress" id="signUp">
              Crear cuenta
            </button>
            <div *ngIf="show === '2' && !showProgress" class="group-session second">
              <p class="init-session" *ngIf="show === '2' && !showProgress" style="margin: 30px 0 20px 0;">
                O si ya tiene cuenta, inicie sesión aquí <br><br>
              </p>
              <button class="sign-in create" id="changeToSignIn" (click)="changeForm('1')">Iniciar
                sesión</button>
            </div>
            <mat-progress-bar style="width: 100%; margin: 0; max-width: 350px;" *ngIf="showProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
          <div class="message-sign-up" *ngIf="receptionMessage">
            <p>{{ receptionMessage }}</p>
            <button (click)="changeForm('1')">Ir a Inicio de sesión</button>
          </div>
        </form>
        <form autocomplete="off" method="POST" *ngIf="show === '3'" class="form-sign" [formGroup]="signForm">
          <div *ngIf="!receptionMessage">
            <div class="input-control-error recover">
              <p>Email de usuario *</p>
              <input type="text" id="userId" [ngClass]="{'error-input': signForm.controls.email.value && signForm.controls.email.invalid &&
              signForm.controls.email.touched || !signForm.controls.email.value && signForm.controls.email.touched}"
                formControlName="email" class="input-search" name="" placeholder="Introduce tu email" required>
              <div class="div-error"
                *ngIf="signForm.controls.email.value && signForm.controls.email.invalid && signForm.controls.email.touched">
                {{ 'SIGN.ERRORS.EMAIL_VALID' | translate }}
              </div>
              <div class="div-error" *ngIf="!signForm.controls.email.value && signForm.controls.email.touched"
                [innerHTML]=" 'SIGN.ERRORS.EMAIL_REQUIRED' | translate">
              </div>
            </div>
            <button class="sign-in" [ngClass]="{'ready': signForm.valid }" (click)="login(3)" *ngIf="!showProgress"
              id="sendId">Enviar</button>
            <mat-progress-bar style="width: 100%; margin: 0; max-width: 350px;" *ngIf="showProgress"
              mode="indeterminate">
            </mat-progress-bar>
          </div>
          <div class="message-sign-up" *ngIf="receptionMessage">
            <p>{{ receptionMessage }}</p>
            <button (click)="changeForm('1')">Volver</button>
          </div>
        </form>
      </div>
      <div class="icons-container">
        <div>
          <a target="_blank"
            href="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32015L2366&qid=1610532238138&from=EN">
            <img src="./assets/home/security/1.svg" alt="" aria-label="Reglamento eIDAS">
          </a>
          <a target="_blank" href="https://www.entrust.net/customer/profile?domain=akana.es&lang=en">
            <img class="special-icon" src="./assets/home/security/2.svg" alt="" aria-label="Certificado de confianza">
          </a>
        </div>
        <div>
          <a target="_blank" href="https://www.entrust.com/resources/certificate-solutions/learn/faq">
            <img src="./assets/home/security/3.svg" alt="" aria-label="FAQ">
          </a>
          <a target="_blank"
            href="https://www.bde.es/bde/es/areas/supervision/funcion/Entidades/Entidades_supervisadas.html">
            <img style="width: 110px" src="./assets/home/security/bde.png" alt="" aria-label="Banco de España">
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>
